export default {"src":"/_next/static/media/hamyar.70ea1283.svg","height":816,"width":951,"blurWidth":0,"blurHeight":0};